import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-had-fc-ss-b',
  templateUrl: './had-fc-ss-b.component.html',
  styleUrls: ['./had-fc-ss-b.component.scss']
})
export class HadFcSsBComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal = '';

  ngOnInit() {
    const modal = this.globals.getModalValue();
    if (undefined !== modal) {
      this.section_modal = modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }

}
